<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useVisitorsStore } from '@/shared/store'
  import { useGoogleAnalytics } from '@/shared/composables/useGoogleAnalytics/useGoogleAnalytics'
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'

  interface Emits {
    (e: 'click'): void
  }

  const emit = defineEmits<Emits>()

  const route = useRoute()
  const visitorsStore = useVisitorsStore()
  const gaService = useGoogleAnalytics()

  const pageName = computed(() => route.params.page || route.name)
  const entryType = visitorsStore.getAnalyticsEntryType

  const onTrackEvent = () => {
    emit('click')
    gaService.sendEventsByContactUs('contact_us', pageName.value, entryType)
  }
</script>

<template>
  <div class="need-help-button" data-test="need-help-button" @click="onTrackEvent">
    <!-- @vue-ignore -->
    <IconQC name="chat" size="lg" :color="$qicConnect.colors.icn.srf.tertiary" />
    <span class="need-help-button__text text-medium">{{ $t('qic_contact_us') }}</span>
  </div>
</template>

<style scoped lang="scss">
  .need-help-button {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);
    padding-top: var(--spacing-7);
    cursor: pointer;

    .need-help-button__text {
      color: var(--colorTxtSrfSecondary);
    }
  }
</style>
